module.exports = __webpack_public_path__ + "media/hyper/images/payments/paypal-70e1a2d08d6b97dbfa4b5128f0eb1545.png";